module.exports = __webpack_public_path__ + "img/facebook.08bd79bd.svg";